import React from 'react';

type Props = {
  /** The color of the icon. */
  color?: string;
};

const carotDown = ({ color }: Props) => (
  <svg height="100%" version="1.1" viewBox="0 0 22 12" width="100%">
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g
        fill={color}
        fillRule="nonzero"
        transform="translate(-1.000000, -1.000000)"
      >
        <path
          d="M6.992188,-4.007812 C6.582031,-4.007812 6.21875,-3.761719 6.0625,-3.386719 C5.910156,-3.007812 6,-2.578125 6.292969,-2.292969 L15.585938,7 L6.292969,16.292969 C6.03125,16.542969 5.925781,16.917969 6.019531,17.265625 C6.109375,17.617188 6.382812,17.890625 6.734375,17.980469 C7.082031,18.074219 7.457031,17.96875 7.707031,17.707031 L17.707031,7.707031 C18.097656,7.316406 18.097656,6.683594 17.707031,6.292969 L7.707031,-3.707031 C7.519531,-3.902344 7.261719,-4.007812 6.992188,-4.007812 Z"
          transform="translate(11.992930, 7.003164) rotate(-270.000000) translate(-11.992930, -7.003164) "
        />
      </g>
    </g>
  </svg>
);

export default carotDown;
